import DatePicker from './DatePicker';
import SingleDatePicker from './SingleDatePicker';
import DateRangePicker from './DateRangePicker';

DatePicker.SingleDatePicker = SingleDatePicker;
DatePicker.DateRangePicker = DateRangePicker;

export default DatePicker;
